import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/grid.svg
 */
const IconGrid: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2.941A1.943 1.943 0 012.942 1h18.116A1.945 1.945 0 0123 2.941v18.117A1.943 1.943 0 0121.058 23H2.953a1.944 1.944 0 01-1.943-1.942L1 2.94zm1.283 6.145v5.825h5.501V9.086h-5.5zm6.795 0v5.825H14.9V9.086H9.078zm0-6.792v5.498H14.9V2.294H9.078zm0 13.902v5.5H14.9v-5.5H9.078zm7.116-7.118v5.824h5.502V9.078h-5.502zM2.934 2.286a.643.643 0 00-.642.64V7.78h5.501V2.28l-4.859.005zm18.117 19.41a.643.643 0 00.643-.64v-4.854h-5.48v5.502l4.837-.007zm.643-13.912V2.931a.64.64 0 00-.643-.641h-4.855v5.498l5.497-.004zM2.28 21.045a.64.64 0 00.642.641h4.853v-5.5h-5.5l.005 4.859z"
      fill="currentColor"
    />
  </svg>
);

export default IconGrid;
